<template>
  <div id="optOutSurvey">
    <el-card
      :style="{width: dialogWidth}"
      :body-style="{padding: dialogPadding}"
      shadow="hover"
    >
      <div class="title">
        {{ $t('coworker.optOut.title') }}
      </div>

      <div class="description">
        <!-- Before opting out of this program, please note that you are choosing to no longer
        participate in the leadership development journey of
        <b><i>{{ user.leader.first_name }} {{ user.leader.last_name }}</i></b>. -->
        <p>
          <i18n path="coworker.optOut.pleaseNote">
            <template #leader>
              <b>{{ user.leader.first_name }} {{ user.leader.last_name }}</b>
            </template>
          </i18n>
        </p>

        <p>
          {{ $t('coworker.optOut.suggest') }}
        </p>

        <p>
          {{ $t('coworker.optOut.pleaseContinue') }}:
        </p>
      </div>

      <el-form
        ref="loginForm"
        :model="input"
        :rules="rules"
      >
        <el-form-item prop="radio">
          <el-radio-group
            v-model="input.radio"
            class="selectGroup"
          >
            <el-radio
              v-for="(reason, key) in reasons"
              :key="key"
              :label="reason.value"
            >
              {{ $t(`coworker.optOut.reason_${reason.value}`) }}
            </el-radio>
          </el-radio-group>
        </el-form-item>

        <el-form-item
          v-if="input.radio === 4"
          prop="verbatim"
        >
          <el-input
            v-model="input.verbatim"
            type="textarea"
            class="verbatim"
            :autosize="{minRows: 2, maxRows: 4}"
            maxlength="250"
            :placeholder="$t('coworker.optOut.pleaseInput')"
            show-word-limit
          />
        </el-form-item>
      </el-form>

      <div class="action">
        <el-button
          type="primary"
          round
          :disabled="input.radio === 0"
          @click="submit"
        >
          {{ $t('common.submit') }}
        </el-button>
      </div>
    </el-card>
  </div>
</template>

<script>
import DialogSetting from '@/mixins/dialog';
import api from '@/api';

export default {
  mixins: [DialogSetting],

  props: {
    user: {
      type: Object,
      default: null,
    },
  },

  data() {
    return {
      input: {
        radio: 0,
        verbatim: '',
      },
      rules: {
        radio: [{
          required: true,
          message: this.$t('coworker.optOut.pleaseSelect'),
          trigger: ['blur', 'change'],
        }],
        verbatim: [{
          required: true,
          message: this.$t('coworker.optOut.pleaseFill'),
          trigger: ['blur', 'change'],
        }],
      },
      reasons: [
        { value: 1 },
        { value: 2 },
        { value: 3 },
        { value: 4 },
      ],
    };
  },

  methods: {
    async submit() {
      try {
        await this.$refs.loginForm.validate();
        await this.$confirm(this.$t('coworker.optOut.areYouSure'), '', {
          confirmButtonText: this.$t('coworker.optOut.title'),
          cancelButtonText: this.$t('common.cancel'),
          center: true,
        });

        let description;
        if (this.input.radio !== 4) {
          description = this.reasons.find((el) => el.value === this.input.radio).label;
        } else {
          description = this.input.verbatim;
        }

        await api.submitOptOut(this.$route.params.id, {
          description,
        });
        this.$emit('submitSuccess');
      } catch (err) {
        // console.log(err);
        // form validation error throw false
        // click on cancel option in confirm modal throw 'cancel'
        if (err && err !== 'cancel') {
          if (err.msg) {
            this.$emit('submitError', err.msg);
          } else {
            this.$emit('submitError');
          }
        }
      }
    },
  },
};
</script>

<style lang="scss" scoped>
#optOutSurvey {
  .el-card {
    margin: 0 auto;

    .title {
      font-weight: bold;
      font-size: 24px;
      margin-bottom: 25px;
    }

    .description {
      margin-bottom: 25px;
    }

    .selectGroup {
      display: flex;
      flex-direction: column;

      .el-radio {
        padding: 5px 0;

        &.is-checked {
          .el-radio__label {
            color: white;
          }
        }
      }
    }

    .action {
      text-align: center;
    }
  }
}
</style>
